import { connect } from 'react-redux';
import { IStateDepartment, IStoreState } from 'src/entity/StateEntity';
import DepartmentAdminDetailPage from 'src/components/views/DepartmentAdmin/DepartmentAdminDetailPage';
import { Dispatch } from 'redux';

const mapStateToProps = ({
  departmentState,
}: IStoreState) => ({
  departmentState,
});

const mapDispatchToProps = (dispatch: Dispatch<IStateDepartment>) => {
  return {
    dispatch,
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(DepartmentAdminDetailPage);



// WEBPACK FOOTER //
// ./src/containers/DepartmentAdminDetail.ts